import { connect } from 'react-redux'
import VideoVolumeButton from '../../components/buttons/simpleVideoVolumeButton'
import { VideoPlayerActions } from 'aria-viewer/players/videoplayer'

const mapStateToProps = ({ video }, ownProps) => {
    return {
        // videoVolume: video.getIn(['videoVolume']),
        // isVideoVolumeMuted: video.getIn(['isVideoVolumeMuted']),
        // isVolumeBarVisible: video.getIn(['isVolumeBarVisible']),
        videoVolume: 0,
        isVideoVolumeMuted: false,
        isVolumeBarVisible: false,
        player: ownProps.player,
    }
}

const mapDispatchToProps = (dispatch, getState) => {
    return {
        setVideoVolume: volume => dispatch(VideoPlayerActions.setVideoVolume(volume)),
        toggleVideoVolumeBarVisibility: () => dispatch(VideoPlayerActions.toggleVideoVolumeBarVisibility()),
    }
}
const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    setVideoVolume: volume => {
        dispatchProps.setVideoVolume(volume)
        stateProps.player.setVolume(volume / 100.0)
    },
})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(VideoVolumeButton)
